import styled, { css } from 'styled-components'
import { tokens } from '@arvoreeducacao/bonsai-ds'
import { Modal } from '../../lib/modals'

export const StyledModal = styled(Modal)`
  max-width: 500px;
  width: 100%;
  padding-left: ${tokens.spacing.spacing_12}px;
  padding-right: ${tokens.spacing.spacing_12}px;
  padding-bottom: 0;
`
export const ModalTitle = styled.h4`
  font-size: ${tokens.sizes.h[5].tablet};
  line-height: 30px;
  font-weight: 700;
  text-align: center;
  margin-top: 0;
  margin-bottom: ${tokens.spacing.spacing_16}px;
`

export const ModalDescription = styled.div<{
  center?: boolean
  isText?: boolean
}>`
  width: 100%;
  font-weight: ${tokens.fontWeights.regular};
  font-size: ${tokens.fontSize.medium};
  line-height: ${tokens.lineHeight.medium}%;
  margin: 0;
  color: ${tokens.colors.dark5};

  p {
    margin: 0 auto;
    max-width: 312px;
  }

  ${props =>
    props.center &&
    css`
      text-align: center;
      overflow: auto;
      margin: 0 auto 1rem;
    `}

  ${props =>
    props.isText &&
    css`
      max-width: 312px;
    `}

  img {
    object-fit: cover;
    width: 100%;
  }
`

export const ModalContent = styled.div`
  margin-top: ${tokens.spacing.spacing_32}px;
`

export const StyledRow = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 32px;
`

export const ModalItem = styled.div`
  width: 48px;
  height: 48px;
  background-color: ${tokens.colors.tertiaryLight};
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const ModalTextItem = styled.h4`
  text-align: center;
  color: ${tokens.colors.tertiaryDark};
  font-weight: bold;
  font-size: ${tokens.fontSize.medium};
  line-height: ${tokens.lineHeight.medium}%;
  margin: 0;
`
export const ModalSubtitle = styled.h5`
  font-weight: ${tokens.fontWeights.bold};
  font-size: ${tokens.fontSize.medium};
  line-height: ${tokens.lineHeight.medium}%;
  margin: 0 0 ${tokens.spacing.spacing_8}px;
  color: ${tokens.colors.dark6};
`

export const CustomImage = styled.img`
  margin-bottom: 1rem;
`
